import type { ColumnDef } from '@tanstack/react-table';
import type { ProvisioningDocument } from './types';
import styles from './page.module.scss';

// The Document ID and Title columns every provisioning documents table leads with.
export const DOCUMENT_LINK_COLUMNS: ColumnDef<ProvisioningDocument>[] = [
  {
    id: 'documentId',
    accessorKey: 'documentId',
    header: 'Document ID',
    size: 100,
    cell: (info) => {
      const docId = info.row.original.documentId;
      return (
        <a href={`/documents/${docId}`} className={styles.docLink}>
          {docId}
        </a>
      );
    },
  },
  {
    id: 'documentTitle',
    accessorKey: 'documentTitle',
    header: 'Title',
    size: 250,
    cell: (info) => {
      const title = info.getValue() as string;
      const docId = info.row.original.documentId;
      return (
        <a href={`/documents/${docId}`} className={styles.docLink}>
          {title || 'Untitled'}
        </a>
      );
    },
  },
];
